import './checkbox-choice.css';
import { h } from 'preact';

export default function CheckboxChoice({ id, name, text, value, matchCount, isChecked, onChangeHandler }) {
	function onChange() {
		if (typeof onChangeHandler === 'function') {
			onChangeHandler(name, value);
		}
	}

	return (
		<li class="checkbox-filter-choice-container filter-choice-container">
			<input onChange={onChange} name={name} id={id} type="checkbox" checked={isChecked} />
			<label class={`checkbox-filter-choice-label filter-choice-label filter-choice-value-${value}`} for={id}>{text}</label>
			{typeof matchCount === 'number' ?
				<span class="filter-choice-match-count">{matchCount}</span> : ''}
		</li>
	);
}
